module.exports = __webpack_public_path__ + "static/media/icon-eye.9068c8e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-eye.svg
// module id = 1241
// module chunks = 19